import React, { useEffect } from 'react';
import OxbridgeLandingPage from '../../features/specialty/oxbridge';

export default function OxbridgeLandingRoute() {
  useEffect(() => {
    document.title = "IVORI — Oxbridge Interview Prep";
    window.scrollTo(0, 0);
  }, []);

  return <OxbridgeLandingPage />;
}
